/**
 * Utilities for persisting navigation state during authentication flows
 */

const NAVIGATION_STATE_KEY = 'zapt_requests_nav_state';

export const navigationState = {
  /**
   * Save the current navigation state before authentication
   */
  save(state) {
    try {
      const stateToSave = {
        ...state,
        timestamp: Date.now()
      };
      localStorage.setItem(NAVIGATION_STATE_KEY, JSON.stringify(stateToSave));
      // console.log('Navigation state saved:', stateToSave);
    } catch (error) {
      console.error('Failed to save navigation state:', error);
    }
  },

  /**
   * Restore navigation state after authentication
   */
  restore() {
    try {
      const saved = localStorage.getItem(NAVIGATION_STATE_KEY);
      if (!saved) return null;

      const state = JSON.parse(saved);
      
      // Check if state is recent (within 10 minutes)
      const isRecent = Date.now() - state.timestamp < 10 * 60 * 1000;
      if (!isRecent) {
        this.clear();
        return null;
      }

      // console.log('Navigation state restored:', state);
      return state;
    } catch (error) {
      console.error('Failed to restore navigation state:', error);
      this.clear();
      return null;
    }
  },

  /**
   * Clear saved navigation state
   */
  clear() {
    try {
      localStorage.removeItem(NAVIGATION_STATE_KEY);
      // console.log('Navigation state cleared');
    } catch (error) {
      console.error('Failed to clear navigation state:', error);
    }
  }
};